// extracted by mini-css-extract-plugin
module.exports = {"title":"NotificationWrite_title_DizYY","footer":"NotificationWrite_footer_oxCT6","write":"NotificationWrite_write_1WfF5"};